jQuery(window).ready(function($) {
  if($(".mb-water-slider").length > 0){
		initiateSlides($(".mb-water-slider"));
	}
  if($(".mb-bottom-slider").length > 0){
      if(window.innerWidth < 600){
        $(".mb-bottom-slider").attr("data-slide-num", "2");
      }
      else if(window.innerWidth < 1080){
          $(".mb-bottom-slider").attr("data-slide-num", "3");
        }
		initiateSlides($(".mb-bottom-slider"));
       
	}
	function initiateSlides(el){
        console.log("initateSlides");
        $(".mb-a-slide:last-of-type img", el).attr("loading", "eager");
		var cloneRight = $(".mb-a-slide", el).last().clone();
		$(".mb-a-slide", el).first().replaceWith(cloneRight);
		var slides = $(".mb-a-slide", el).length;
		var slidesPer = el.data("slide-num");
        
		var trackWidth = (100 / slidesPer) * slides;
		var gaps = 2 * (slides - 1);
		var sendLeft = 100 / slidesPer;
		$(".mb-slide-railings", el).css("width", trackWidth + "%").css("left", "-" + sendLeft + "%");
		
		//	Slide width
		var slideWidth = 100 / slidesPer;
		$(".mb-a-slide", el).css("width", slideWidth + "%").show();
      
		$(".mb-slide-to-the-left", el).click(function(e){
            console.log("clicked");
			chaChaRealSmooth("left", el);
		});
		$(".mb-slide-to-the-right", el).click(function(e){
			chaChaRealSmooth("right", el);
		});
        var timing = el.data("slideshow-speed");
        if(timing){
           var calcTiming = parseInt(timing) * 1000;
          console.log(calcTiming);
          setInterval(chaChaRealSmooth, calcTiming, "right", el);
        }
	}
	function chaChaRealSmooth(direction, el){
		var slides = $(".mb-a-slide", el).length;
		var slidesPer = el.data("slide-num");
		var trackWidth = (100 / slidesPer) * slides;
		var left = 100 / slidesPer;
		var cssLeft = $(".mb-slide-railings", el).attr("style");
		var getPercent = parseCSS(cssLeft);
		var minusMe = parseInt(getPercent) + parseInt(left);
        var speed = el.data("speed");
        if(!speed){
          speed = 1000;
        }
        
		if(direction == "right"){
			minusMe = parseInt(getPercent) - parseInt(left);
		}
        var slideNum = $(".mb-slide-selected");
		$(".mb-slide-railings", el).animate({
			left: minusMe + "%"
		}, speed, function() {
			if(direction == "right"){
				var newLeft = 100 / slidesPer;
				var cloneCurrent = $(".mb-a-slide", el).first().next().clone();
				$(".mb-a-slide", el).first().remove();
				$(".mb-slide-railings", el).append(cloneCurrent);
				$(".mb-slide-railings", el).css("left", "-" + newLeft + "%");
                var nextID = slideNum.next().attr("data-slide-num");
                slideNum.removeClass("mb-slide-selected").next().addClass("mb-slide-selected");
                $(".mb-bullet-selected").removeClass("mb-bullet-selected");
                $('div[data-slide-num="' + nextID + '"]', el).addClass("mb-bullet-selected");
			}
			else {
				var cloneBackwards = $(".mb-a-slide", el).last().prev().clone();
				$(".mb-a-slide", el).last().remove();
				$(".mb-slide-railings", el).prepend(cloneBackwards);
				var newLeft = 100 / slidesPer;
				$(".mb-slide-railings", el).css("left", "-" + newLeft + "%");
              slideNum.removeClass("mb-slide-selected").prev().addClass("mb-slide-selected");
                var prevID = slideNum.prev().attr("data-slide-num");
                $(".mb-bullet-selected").removeClass("mb-bullet-selected");
                $('div[data-slide-num="' + prevID + '"]', el).addClass("mb-bullet-selected");
			}
		});
		
	}
  function parseCSS(css, grab = "left"){
		var parseMe = css.split(grab + ":");
		parseMe = parseMe[1].split(";");
		parseMe = parseMe[0].split("%");
		return parseMe[0];
	}
});